import { TEMPLATE_FIELD_TYPE } from '../../src/constants';

const getSelected = (items, selected, key = 'id') => {
    if (selected && items && items?.length >= 1) {
        return items.find((item) => item[key] === selected.value);
    }
};

const getOptions = (list) => !list || list?.length <= 0 ? [] : list.map((l) => ({ label: l.name, value: l.id }));

const getDate = (value, type) => {

    let parsed;

    try {

        // check if a value is a moraware date (because moraware sucks SO MANY fucking dicks 🤮)
        if (typeof value !== 'number' && value.length == 10 && value.split('-').length == 3) {
            return value; // return as text because moraware is built by monkeys
        }

        switch (type) {
            case TEMPLATE_FIELD_TYPE.DATE.value:
                parsed = new Date(value).toLocaleDateString();
                break;

            case TEMPLATE_FIELD_TYPE.DATE_TIME.value:
                parsed = new Date(value).toLocaleString();
                break;

            default:
                return value;
        }

        if (parsed == 'Invalid Date') {
            throw Error('Invalid Date');
        } else {
            return parsed;
        }

    } catch (err) {
        return value;
    }
};

export default {
    getSelected,
    getOptions,
    getDate
};